import React from 'react';

export function ChartContainer({ title, children, actions }) {
  return (
    <div
      style={{
        backgroundColor: '#ffffff',
        borderRadius: 8,
        border: '1px solid #e2e8f0',
        padding: 24
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: 24
        }}
      >
        <h3
          style={{
            color: '#0f172a',
            fontSize: 18,
            fontWeight: 600,
            margin: 0
          }}
        >
          {title}
        </h3>

        {actions && <div>{actions}</div>}
      </div>

      <div>{children}</div>
    </div>
  );
}
